import { cn } from '../../utils'

type ToggleButtonProps = {
	value: string
	options: { label: string; value: string }[]
	onChange: (val: any) => void
	className?: string
}

export function ToggleButton({
	value,
	options,
	onChange,
	className,
}: ToggleButtonProps) {
	return (
		<div
			className={cn(
				'flex p-1 rounded-full bg-gray-50 text-xs font-medium',
				className,
			)}
		>
			{options.map((option) => (
				<div
					onClick={() => onChange(option.value)}
					className={cn(
						'flex items-center h-8 px-4 rounded-full cursor-pointer',
						{
							'bg-primary': value === option.value,
							'text-primary-foreground': value === option.value,
						},
					)}
					key={option.value}
				>
					{option.label}
				</div>
			))}
		</div>
	)
}
